import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import FeaturesSection from "./components/FeaturesSection";
import InteractiveDemo from "./components/InteractiveDemo";
import PricingSection from "./components/PricingSection";
import VideoSection from "./components/VideoSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import BookDemoModal from "./components/BookDemoModal";

const Home = () => {
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

    const handleBookDemo = () => {
        window.open(
            "https://docs.google.com/forms/d/e/1FAIpQLSeSw1JKGrFydRwtW0OmaMVGNQqHwvw1CPLDYGPF-qY80jK_cQ/viewform?usp=publish-editor",
            "_blank",
        );
        // setIsDemoModalOpen(true);
    };

    return (
        <div className="min-h-screen bg-white">
            <Header onBookDemo={handleBookDemo} />

            <main className="pt-20">
                <Hero onBookDemo={handleBookDemo} />
                <ProblemSection />
                <div id="features">
                    <FeaturesSection />
                </div>
                <div id="demo">
                    <InteractiveDemo />
                </div>
                <VideoSection />
                <div id="pricing">
                    <PricingSection onBookDemo={handleBookDemo} />
                </div>
                <div id="faq">
                    <FAQSection />
                </div>
            </main>

            <Footer />

            <BookDemoModal
                isOpen={isDemoModalOpen}
                onClose={() => setIsDemoModalOpen(false)}
            />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
